export class ListAzureSubnets200Response {
    'subnets';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<ListAzureSubnets200ResponseSubnetsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSubnets200Response.attributeTypeMap;
    }
    constructor() {
    }
}
